import { Reducer } from 'redux';
import { DashboardMenuState, DashboardMenuTypes } from './types';

const INITIAL_STATE: DashboardMenuState = {
  data: [],
  loading: false,
};

const reducer: Reducer<DashboardMenuState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DashboardMenuTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DashboardMenuTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        ...action.payload,
      };
    case DashboardMenuTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
